// src/pages/Home.tsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeroCarousel from '../components/HeroCarousel';
import ArticleModal from '../components/ArticleModal';
import QuizGame from '../components/QuizGame'; // Add this import


const Home: React.FC = () => {
  const [activeArticle, setActiveArticle] = useState<string | null>(null);
  const navigate = useNavigate();

  const featuredContent = [
    {
      icon: '📖',
      title: 'Complete Quran',
      description: 'Read and understand the Holy Quran with authentic translations and detailed transliteration.',
      path: '/quran'
    },
    {
      icon: '🕌',
      title: 'Dua & Dhikr',
      description: 'Authentic supplications from Quran and Sunnah for every occasion and emotional state.',
      path: '/dua-dhikr'
    },
    {
      icon: '💫',
      title: 'Emotional Support',
      description: 'Find comfort and Islamic guidance tailored to your current emotional state and situation.',
      path: '/my-mood'
    },
    {
      icon: '📚',
      title: 'Articles Library',
      description: 'Deep dive into comprehensive Islamic knowledge and spiritual guidance articles.',
      path: '/articles'
    }
  ];

  const handleOpenArticle = (articleId: string) => {
    setActiveArticle(articleId);
  };

  return (
    <div>
      {/* Hero Carousel Section */}
      <section className="section-padding" style={{
        backgroundColor: 'var(--bg-secondary)',
        padding: '80px 0'
      }}>
        <div className="container">
          <HeroCarousel onOpenArticle={handleOpenArticle} />
        </div>
      </section>

      {/* Learn Prayer Section */}
      <section className="section-padding">
        <div className="container">
          <div className="section-title">
            <h2>Learn How to Pray</h2>
            <p>Step-by-step guide to performing Salah with all necessary duas and instructions</p>
          </div>

          <div style={{
            textAlign: 'center',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '18px',
              lineHeight: '1.7',
              marginBottom: '32px'
            }}>
              Prayer (Salah) is the second pillar of Islam and the first thing we'll be asked about on the Day of Judgment.
              Learn the proper way to perform all five daily prayers and optional prayers.
            </p>
            <Link to="/learn-prayer" className="btn-primary" style={{
              textDecoration: 'none',
              fontSize: '18px',
              padding: '16px 32px'
            }}>
              Learn Prayer Step by Step
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section-padding" style={{ backgroundColor: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="section-title">
            <h2>Comprehensive Islamic Resources</h2>
            <p>Carefully curated content to support your spiritual journey</p>
          </div>

          {/* Quran in English Resource Card (Custom Added) */}
          <div className="resource-card" onClick={() => navigate('/english-quran')} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: 'var(--bg-primary)',
            padding: '20px 24px',
            borderRadius: '12px',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            marginBottom: '32px',
            transition: 'transform 0.2s ease-in-out'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div className="resource-icon" style={{
                backgroundColor: '#4CAF50',
                color: 'white',
                width: '64px',
                height: '64px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                fontSize: '28px'
              }}>
                <i className="fas fa-book-quran"></i>
              </div>
              <div className="resource-content">
                <h3 style={{ margin: 0, fontSize: '1.5rem', color: 'var(--text-primary)' }}>
                  Quran in English
                </h3>
                <p style={{
                  margin: '8px 0',
                  color: 'var(--text-secondary)',
                  lineHeight: '1.6'
                }}>
                  Read and listen to the complete Quran with English translation and audio recitation.
                </p>
                <div className="resource-meta" style={{
                  display: 'flex',
                  gap: '12px',
                  color: 'var(--text-secondary)',
                  fontSize: '0.9rem'
                }}>
                  <span><i className="fas fa-headphones"></i> Audio Available</span>
                  <span><i className="fas fa-language"></i> English Translation</span>
                </div>
              </div>
            </div>
            <div className="resource-arrow" style={{
              color: 'var(--text-primary)',
              fontSize: '20px'
            }}>
              <i className="fas fa-arrow-right"></i>
            </div>
          </div>

          {/* Existing Resource Cards */}
          <div className="grid-3">
            {featuredContent.map((item, index) => (
              <Link key={index} to={item.path} style={{ textDecoration: 'none' }}>
                <div className="card" style={{ height: '100%' }}>
                  <div style={{
                    fontSize: '48px',
                    marginBottom: '24px',
                    textAlign: 'center',
                    opacity: '0.9'
                  }}>
                    {item.icon}
                  </div>
                  <h3 style={{
                    fontSize: '1.375rem',
                    fontWeight: '600',
                    marginBottom: '16px',
                    textAlign: 'center',
                    color: 'var(--text-primary)'
                  }}>
                    {item.title}
                  </h3>
                  <p style={{
                    color: 'var(--text-secondary)',
                    textAlign: 'center',
                    lineHeight: '1.7'
                  }}>
                    {item.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
       {/* Islamic Knowledge Quiz Section - ADDED HERE */}
      <QuizGame />

      {/* CTA Section */}
      <section className="section-padding">
        <div className="container">
          <div className="card" style={{
            backgroundColor: 'var(--accent-primary)',
            color: 'var(--text-primary)',
            textAlign: 'center',
            padding: '60px 40px',
            border: 'none'
          }}>
            <h2 className="heading-font" style={{
              fontSize: '2.5rem',
              fontWeight: '600',
              marginBottom: '20px'
            }}>
              Support Our Mission
            </h2>
            <p style={{
              fontSize: '18px',
              marginBottom: '32px',
              opacity: '0.9',
              maxWidth: '600px',
              margin: '0 auto 32px',
              lineHeight: '1.7'
            }}>
              Your generous donations enable me to maintain this platform, develop new features,
              and continue serving the global Muslim community with authentic Islamic content.
            </p>
            <Link to="/donate" className="btn-primary" style={{
              textDecoration: 'none',
              backgroundColor: 'var(--bg-primary)',
              color: 'var(--text-primary)'
            }}>
              Support ImanVerse
            </Link>
          </div>
        </div>
      </section>


      {/* Article Modal */}
      <ArticleModal
        id={activeArticle}
        onClose={() => setActiveArticle(null)}
      />
    </div>
  );
};

export default Home;